import {Directive, HostListener, Input} from '@angular/core';

@Directive({
  selector: '[appAlpha]',
})
export class AlphabetTypeDirective {

  @Input() appAlpha: boolean;

  constructor() {
  }

  @HostListener('keypress', ['$event']) onKeyPress(event) {
    if (this.appAlpha) {
      const charCode = event.key;
      const alphaRegex = new RegExp(`^[a-zA-ZäÄöÖüÜß .-]+$`);
      if (!alphaRegex.test(charCode)) {
        event.preventDefault();
      }
      return true;
    }
  }
}
